import { render, staticRenderFns } from "./Lyb.vue?vue&type=template&id=57863a06&scoped=true&"
import script from "./Lyb.vue?vue&type=script&lang=js&"
export * from "./Lyb.vue?vue&type=script&lang=js&"
import style0 from "./Lyb.vue?vue&type=style&index=0&id=57863a06&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57863a06",
  null
  
)

export default component.exports